import { useStaticQuery, graphql } from "gatsby";

export default () => {
  const data = useStaticQuery(graphql`
    {
      craft {
        categories(group: "headerFeaturesCategory", siteId: "2") {
          ... on Craft_headerFeaturesCategory_Category {
            slug
            title
          }
        }
        entries(siteId: "2", section: "featurePages", status: "live") {
          typeHandle
          ... on Craft_featurePages_featurePages_Entry {
            slug
            featurePageUrlDirectory {
              slug
            }
            headerFeaturesCategory {
              slug
            }
          }
        }
      }
    }
  `);

  return data.craft;
};
